<!-- Popover element -->
<div id="popover"
  class="w-90 h-60 m-4 p-1 rounded-2xl bg-lugano-black shadow-lg flex flex-col overflow-hidden opacity-0 transition-opacity duration-300 ease-in-out" [class]="{'opacity-100': isVisible}">

  <!-- Node Info -->
  <div class="h-10 pt-1 p-2 text-lugano-white rounded-t-2xl overflow-hidden flex justify-center items-center">
    <div class="mx-2 flex items-baseline">
      <p class="me-1 text-sm text-lugano-white/50">Section</p>
      <p class="text-base font-bold">{{ nodeData[0] }}</p>
    </div>
    @if (nodeData[1]) {
      <div class="mx-2 flex items-baseline">
        <p class="me-1 text-sm text-lugano-white/50">Row</p>
        <p class="text-base font-bold">{{ nodeData[1] }}</p>
      </div>
    }
    @if (nodeData[2]) {
      <div class="mx-2 flex items-baseline">
        <p class="me-1 text-sm text-lugano-white/50">Seat</p>
        <p class="text-base font-bold">{{ nodeData[2] }}</p>
      </div>
    }
  </div>

  <!-- Thumbnail -->
  <div class="w-full relative flex-1 rounded-b-xl overflow-hidden">
    @if (isLoading) {
    <div class="custom-loader-wrapper">
      <div class="custom-loader"></div>
    </div>
    }
    
    @if (thumbnailSrc && thumbnailSrc !== null && thumbnailSrc !== '') {
      <img [src]="thumbnailSrc" class="w-full h-full object-cover" alt="thumbnail">
    }
  </div>

</div>